import React from 'react';
import moment from 'moment';
import { Tag, Tooltip } from 'antd';
import Typography from '../../../components/Typography';
import COLORS from '../../../util/constants/colors';
import { formatDOB, formatName, formatPhoneNumber } from '../helpers';

const emptyText = (value = '--') => (
  <Typography className="follow-up-empty-cell" variant="text" size="small" color={COLORS.TEXT_TERTIARY_LITE}>
    {value}
  </Typography>
);

const formattedDateTime = (value) => {
  if (!value) return emptyText();

  return (
    <div className="follow-up-date-cell">
      <Typography variant="text" size="small" color={COLORS.TEXT_PRIMARY_LITE} bold>
        {moment(value).format('MM/DD/YYYY')}
      </Typography>
      <Typography variant="text" size="small" color={COLORS.TEXT_TERTIARY_LITE}>
        {moment(value).format('hh:mm A')}
      </Typography>
    </div>
  );
};

const followUpColumns = [
  {
    title: 'Caller',
    dataIndex: 'caller_name',
    key: 'caller_name',
    fixed: 'left',
    render: (name, record) => (
      <div className="follow-up-caller-cell">
        <Typography variant="text" size="small" bold>
          {formatName(name) || 'Not Provided'}
        </Typography>
        <Typography variant="text" size="xsmall" color={COLORS.TEXT_TERTIARY_LITE}>
          {record.caller_dob ? formatDOB(record.caller_dob) : '--/--/----'}
        </Typography>
      </div>
    ),
  },
  {
    title: 'Phone',
    dataIndex: 'caller_phone',
    key: 'caller_phone',
    render: (phone) => (
      <Typography variant="text" size="small" color={COLORS.TEXT_SECONDARY_LITE}>
        {formatPhoneNumber(phone) || '--'}
      </Typography>
    ),
  },
  {
    title: 'Received',
    dataIndex: 'received_at',
    key: 'received_at',
    render: formattedDateTime,
  },
  {
    title: 'Current Status',
    dataIndex: 'current_status',
    key: 'current_status',
    render: (status) => (
      <div className={status?.name ? 'follow-up-status-pill' : 'follow-up-status-pill empty'}>
        {status?.name || 'New'}
      </div>
    ),
  },
  {
    title: 'Follow-ups',
    dataIndex: 'followup_count',
    key: 'followup_count',
    render: (count = 0) => {
      const safeCount = count || 0;

      return (
        <div className="follow-up-attempt-badge">
          <strong>{safeCount}</strong>
          <span>{safeCount === 1 ? 'follow-up' : 'follow-ups'}</span>
        </div>
      );
    },
  },
  {
    title: 'Due',
    dataIndex: 'due_date',
    key: 'due_date',
    render: (dueDate, record) => {
      if (!dueDate) return emptyText();

      return (
        <Tag className={record.overdue ? 'follow-up-due-pill overdue' : 'follow-up-due-pill'}>
          {moment(dueDate).format('MM/DD/YYYY')}
        </Tag>
      );
    },
  },
  {
    title: 'Current Owner',
    dataIndex: 'current_owner',
    key: 'current_owner',
    render: (owner) => {
      const safeOwner = owner || {};

      return (
        <Tooltip title={safeOwner.email || ''}>
          <div className={safeOwner.name || safeOwner.email ? 'follow-up-owner-pill' : 'follow-up-owner-pill empty'}>
            {safeOwner.name || safeOwner.email || 'Unassigned'}
          </div>
        </Tooltip>
      );
    },
  },
  {
    title: 'Final outcome',
    dataIndex: 'final_outcome',
    key: 'final_outcome',
    render: (outcome) => (
      outcome?.name
        ? (
          <Tag className={outcome.terminal ? 'follow-up-outcome-tag done' : 'follow-up-outcome-tag'}>
            {outcome.name}
          </Tag>
        )
        : <Tag className="follow-up-outcome-tag open">Open</Tag>
    ),
  },
];

export default followUpColumns;
